import queryString from 'query-string';

export const generateQueryParamsFromStringQuery = (queryParams?: string) => {
  return queryParams
    ? queryString.parse(queryParams, {
        sort: false,
      })
    : {};
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface ObjectQueryParams {
  [key: string]: string | number | string[] | null | undefined;
}

export const generateQueryParamsFromObjectQuery = (
  ObjectQuery: ObjectQueryParams
) =>
  Object.keys(ObjectQuery).reduce((accumulator, objectKeyCurrentValue) => {
    if (
      ObjectQuery[objectKeyCurrentValue] &&
      objectKeyCurrentValue !== 'totalItems'
    ) {
      if (accumulator === '?') {
        return `${accumulator}${objectKeyCurrentValue}=${ObjectQuery[objectKeyCurrentValue]}`;
      }
      return `${accumulator}&${objectKeyCurrentValue}=${ObjectQuery[objectKeyCurrentValue]}`;
    }
    return accumulator;
  }, '?');

export const truncateText = (input: string, length = 20) => {
  return input.length > length ? `${input.substring(0, length)}...` : input;
};

export const regexNotNumber = (value: string) => {
  const regex = /[^0-9]/g;
  return regex.test(value);
};

export const regexIsPhoneNumber = (value: string) => {
  const regex = /^[0-9|+][0-9]*$/g;
  return regex.test(value);
};

export const formatPhoneNumber = (rawPhoneNumber: string) => {
  const regex = /^0/;
  return rawPhoneNumber.replace(regex, '');
};

export const regexIsEn = (value: string) => {
  const regex = /^en/;
  return regex.test(value);
};

export const isPhoneNumberValid = (value: string) =>
  !!value && regexIsPhoneNumber(value) && value?.length >= 8;
